import { styled } from '@linaria/react';
import { colors, fonts, space } from '../../theme/tokens';

export const Bar = styled.div`
  display: inline-flex;
  align-items: center;
  border: 1px solid ${colors.borderGrey};
  border-radius: 28px;
  background: ${colors.lightGrey};
  overflow: visible;
  height: 44px;

  @media screen and (max-width: 600px) {
    display: none;
  }
`;

export const DotSeparator = styled.span`
  color: ${colors.grey};
  margin: 0 2px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  pointer-events: none;
`;

export const CategoryWrapper = styled.div`
  position: relative;
  display: flex;
  height: calc(100% - 8px);
  margin: 4px;
  margin-right: 0;

  @media screen and (max-width: 600px) {
    display: none;
  }
`;

export const CategoryDropdown = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  min-width: 160px;
  background: ${colors.white};
  border: 1px solid ${colors.borderGrey};
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  z-index: 200;
  overflow: hidden;
  margin-left: -1px;
`;

export const DatesWrapper = styled.div<{ $isFirst?: boolean }>`
  position: relative;
  display: flex;
  height: calc(100% - 8px);
  border-radius: ${({ $isFirst }) => ($isFirst ? '28px 0 0 28px' : '0')};
`;

export const GuestsWrapper = styled.div`
  position: relative;
  display: flex;
  height: calc(100% - 8px);
`;

export const SearchWrapper = styled.div`
  display: flex;
  height: calc(100% - 8px);
  margin: 4px;
  margin-left: 8px;
`;

export const SearchPill = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background: ${colors.white};
  border: 1px solid ${colors.borderGrey};
  cursor: pointer;
  padding: 0 16px;
  height: 100%;
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${colors.fontPrimary};
  white-space: nowrap;
  border-radius: 24px;
  transition: font-weight 0.1s ease;

  &:hover {
    font-weight: ${fonts.weight.semiBold};
  }
`;

export const SearchLabel = styled.span`
  display: inline-flex;
  flex-direction: column;
  align-items: center;

  &::after {
    content: attr(data-text);
    font-weight: ${fonts.weight.semiBold};
    height: 0;
    overflow: hidden;
    visibility: hidden;
    pointer-events: none;
  }
`;

export const DropdownAnchor = styled.div<{ $alignLeft?: boolean }>`
  position: absolute;
  top: calc(100% + 8px);
  left: ${({ $alignLeft }) => ($alignLeft ? '0' : '50%')};
  transform: ${({ $alignLeft }) => ($alignLeft ? 'none' : 'translateX(-50%)')};
  z-index: 200;
`;

export const Pill = styled.button`
  display: flex;
  align-items: center;
  gap: ${space[4]};
  background: ${colors.lightGrey};
  border: 1px solid ${colors.borderGrey};
  cursor: pointer;
  padding: 0 ${space[4]};
  height: 100%;
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${colors.fontPrimary};
  white-space: nowrap;
  border-radius: 24px;
  transition: background 0.15s ease;

  &:hover {
    background: ${colors.lighterGrey};
  }
`;
